module.exports = __webpack_public_path__ + "static/img/banner_zfds.fa832c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banner/banner_zfds.png
// module id = 9eh9
// module chunks = 15